import * as React from 'react';
import { useLocation } from 'react-router';

import { useLocalStorageState } from 'ahooks';
import { fetchFilters, getTableParams } from 'Inventory/utils';
import {
  InventoryTableParams,
  ProductType,
} from 'utils/apiClient/services/inventory/types';

const HistoryObserver: React.FC = () => {
  const { pathname } = useLocation();
  const [currentLocation, setCurrentLocation] = React.useState<string>();
  const itemType = pathname.split('/')[2];
  const key = `${itemType}-table-params`;
  const initialTableParams = React.useMemo(
    () => ({
      [key]: getTableParams(fetchFilters(itemType as ProductType)),
    }),
    [itemType, key]
  );

  const [_, setTableParams] = useLocalStorageState<InventoryTableParams>(
    `${itemType}-table-params`,
    { defaultValue: initialTableParams }
  );

  const resetTableParams = React.useCallback(() => {
    Object.keys(initialTableParams).forEach((k) => {
      if (k === key) {
        setTableParams(initialTableParams[k]);
      }
    });
  }, [key, setTableParams, initialTableParams]);

  const rules = React.useMemo(
    () => [
      (__: string, next: string) => {
        // example on how to create rules
        if (next === '/') {
          // entering home
        }
      },
      (prev: string, next: string) => {
        if (
          /inventory\/products/.test(prev) &&
          !/inventory\/products/.test(next)
        ) {
          resetTableParams();
        }
      },
      (prev: string, next: string) => {
        if (
          /inventory\/services/.test(prev) &&
          !/inventory\/services/.test(next)
        ) {
          resetTableParams();
        }
      },
      (prev: string, next: string) => {
        if (
          /inventory\/giftcards/.test(prev) &&
          !/inventory\/giftcards/.test(next)
        ) {
          resetTableParams();
        }
      },
    ],
    [resetTableParams]
  );

  React.useEffect(() => {
    const prev = currentLocation;
    const next = pathname;
    if (prev && next !== prev) {
      rules.map((fn) => fn(prev, next));
    }
    setCurrentLocation(pathname);
  }, [pathname, currentLocation, rules]);

  return null;
};

export default HistoryObserver;
